var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout l-admin", class: _vm.classes },
    [
      !_vm.noHeader ? _c("k-site-header") : _vm._e(),
      _c(
        "div",
        { staticClass: "left-menu", class: { "menu-open": _vm.menuOpen } },
        [
          _c(
            "div",
            { staticClass: "main-menu", class: { open: _vm.menuOpen } },
            [
              _c(
                "w-btn-icon",
                {
                  staticClass: "toggle",
                  attrs: { size: "3q" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggleMenu.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm.menuOpen
                    ? _c("i-chevron-left", { staticClass: "icon" })
                    : _c("i-chevron-right", { staticClass: "icon" }),
                ],
                1
              ),
              _c("div", { staticClass: "container" }, [
                _c(
                  "div",
                  {
                    directives: [{ name: "bar", rawName: "v-bar" }],
                    staticClass: "scroll",
                  },
                  [
                    _c("div", { staticClass: "inner" }, [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("i-admin", { attrs: { title: "Administration" } }),
                          _c("k-header", [_vm._v("Administration")]),
                          _c("k-admin-menu"),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm.noScroll
            ? _c("div", { staticClass: "main fixed" }, [_vm._t("default")], 2)
            : _c(
                "div",
                {
                  directives: [{ name: "bar", rawName: "v-bar" }],
                  staticClass: "main",
                },
                [_c("div", { staticClass: "inner" }, [_vm._t("default")], 2)]
              ),
        ]
      ),
      _c("overlay"),
      _c("sidebar", { attrs: { pos: "left" } }),
      _c("sidebar", { attrs: { pos: "right" } }),
      _c("modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }